import { useState, useEffect } from 'react'
import { Sun, Moon } from 'lucide-react'
import { LOCAL_KEYS } from '../constants/storageKeys'
import { safeLocalStorage } from '../utils/safeStorage'
import '../css/ThemeToggle.css'

const ThemeToggle = () => {
	const [isDarkMode, setIsDarkMode] = useState(() => {
		return safeLocalStorage.getItem(LOCAL_KEYS.THEME) === 'dark'
	})

	useEffect(() => {
		const root = document.documentElement
		root.classList.add('theme-switching')
		document.body.classList.add('theme-fade')

		const theme = isDarkMode ? 'dark' : 'light'
		const timeouts = [
			setTimeout(() => {
				root.setAttribute('data-theme', theme)
				safeLocalStorage.setItem(LOCAL_KEYS.THEME, theme)

				const metaThemeColor = document.querySelector('meta[name="theme-color"]')
				if (metaThemeColor) {
					metaThemeColor.setAttribute('content', isDarkMode ? '#0f172a' : '#f3f4f6')
				}

				document.body.classList.remove('theme-fade')
			}, 130),
			setTimeout(() => root.classList.remove('theme-switching'), 300),
		]
		return () => timeouts.forEach(clearTimeout)
	}, [isDarkMode])

	const label = isDarkMode ? 'Zu hellem Design wechseln' : 'Zu dunklem Design wechseln'

	return (
		<button
			type='button'
			className='theme-toggle-btn'
			onClick={() => setIsDarkMode(prev => !prev)}
			aria-pressed={isDarkMode}
			aria-label={label}
			title={label}
		>
			{isDarkMode ? <Moon size={20} strokeWidth={2.25} /> : <Sun size={20} strokeWidth={2.25} />}
		</button>
	)
}

export default ThemeToggle
